import facebook from "../../../../../client/src/components/common/redesSociales/imagenesRedes/facelogo.png"
import instagram from "../../../../../client/src/components/common/redesSociales/imagenesRedes/intalogo.png"
import twitter from "../../../../../client/src/components/common/redesSociales/imagenesRedes/logotwit.png"
import youtube from "../../../../../client/src/components/common/redesSociales/imagenesRedes/youtlogo.png"

export const arrayRedes = [
    
        {
          id: 1,
          name: "facebook",
          logo: facebook,
          enlace: "https://www.facebook.com/people/Aventuras-del-Caribe/100063665426054/"
        },
        {
          id: 2,
          name: "instagram",
          logo: instagram,
          enlace: "https://www.instagram.com/aventurasdelvaribe/"
        },
        {
          id: 3,
          name: "twitter",
          logo: twitter,
          enlace: "https://twitter.com/aventurasdelcaribe/"
        },
        {
          id: 4,
          name: "youtube",
          logo: youtube,
          enlace: "https://www.youtube.com/user/aventurasdelcaribe/"
        }
      ];